import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types/i18n'

export default {
  rank: {
    id: 'product_jp_recommendation_carousel_rank',
    defaultMessage: 'rank',
  },
} as Record<string, I18nDefinition>
